<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
           <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img  v-if="URL_MAQIN==1"  src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>课程资料</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content_box clearfix">
        <div class="content_box_r" v-if="hand_show">
          <div class="exam_title">课程资料</div>
          <div class="exam_list" v-for="(item,index) in doc_list" :key="index">
            <div class="exam_list_box1 clearfix" v-if="item.type==7 || item.type==1">
              <div class="hand_img">
                  <img src="../assets/img/pdf.png" alt />
                </div>
                <div class="child_name">{{item.title}}</div>

                <div class="btn_box">
                    <div
                    class="btn"
                    v-if="item.type==7&&item.is_lock ==1"
                    @click="downlaod_click(item.download_url)"
                  >下载</div>
                  <div
                    class="btn"
                    v-if="item.download_url!='' &&  item.type==1&&item.is_lock ==1"
                    @click="downlaod_click(item.download_url)"
                  >下载</div>
                  <div
                    class="btn"
                    v-if="item.is_lock ==0"
                    style="background: initial;border: 0;"
                  >更新中...</div>
                  <div class="btn" v-if="item.type==1&&item.is_lock ==1" @click="look_click(item.chapter_id)">查看</div>
                </div>
            </div>
            <div class="exam_list_box clearfix" v-if="item.type==0">
              <div class="exam_list_l">
                <div class="name">{{item.title}}{{item.sub_title}}</div>
              </div>
              <div class="operate clearfix" >
                <div class="btn haung" @click="detail_click(item.chapter_id)">查看</div>
              </div>
            </div>

          </div>
        </div>
        <div class="content_box_r1" v-else>
          <div class="exam_title">讲义下载</div>
          <div class="exam_list1">暂无讲义</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DocSubject } from "@/api/index";
export default {
  data() {
    return {
      doc_list: [],
      levelList: {},
      hand_show: true,
      MAIN_CLASS:this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN:this.GLOBAL.PLATFORM,
    };
  },
  mounted() {
    // this.$route.query.chapter_id
    // console.log(this.$route.query.chapter_id);

    this.request(this.$route.query.chapter_id, this.$route.query.course_id);
  },
  methods: {
    request(chapter_id, course_id) {
      DocSubject(chapter_id, course_id).then(res => {
        // console.log(res);
        this.doc_list = res;
        if (this.doc_list.length < 1) {
          this.hand_show = false;
        }
      });
    },
    detail_click(chapter_id) {
      this.$router.push({
        path: "handout_detail",
        query: { chapter_id: chapter_id }
      });
    },
     // 点击下载
    downlaod_click(url) {
      window.location.href = url;
    },
    // 点击查看
    look_click(chapter_id) {
      this.$router.push({
        path: "handout_see",
        query: { chapter_id: chapter_id }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: rgba(250, 220, 30, 1);
      }
    }
    .content_box_r {
      float: right;
      padding: 0 50px 50px 50px;
      width: 1268px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .exam_title {
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 24px 0;
        border-bottom: 1px solid #eee;
      }
      .exam_list {
        border-bottom: 1px solid #eee;
        .exam_list_box {
          padding: 30px 0;
          .exam_list_l {
            cursor: pointer;
            .tag {
              float: left;
              width: 23px;
              height: 23px;
              background: rgba(238, 238, 238, 1);
              border-radius: 50%;
              margin-right: 11px;
              text-align: center;
              line-height: 23px;
              img {
                width: 12px;
                height: 12px;
              }
            }
            .name {
              float: left;
            }
          }

          .operate {
            float: right;
            .btn {
              cursor: pointer;
              width: 72px;
              height: 25px;
              background: rgba(0, 69, 96, 0.04);
              border-radius: 4px;
              border: 1px solid rgba(204, 204, 204, 1);
              font-size: 12px;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
              text-align: center;
              line-height: 25px;
              float: left;
              margin-left: 24px;
            }
            .huang {
              background-color: #fadc1e;
              border: 1px solid rgba(250, 220, 30, 1);
            }
            .number {
              float: left;
              line-height: 27px;
              span {
                color: #e84233;
              }
            }
          }
        }
        .exam_list_box1{
            padding: 30px 0;
           .hand_img {
              float: left;
              margin-right: 20px;
              img {
                width: 30px;
              }
            }
            .child_name {
              float: left;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
            .btn_box {
              float: right;
              .number {
                float: left;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000;
                line-height: 27px;
                span {
                  color: rgba(254, 76, 75, 1);
                }
              }
              .btn {
                cursor: pointer;
                margin-left: 24px;
                float: left;
                width: 72px;
                height: 25px;
                background: rgba(250, 220, 30, 1);
                border-radius: 4px;
                border: 1px solid rgba(250, 220, 30, 1);
                font-size: 12px;
                font-weight: 500;
                color: rgba(0, 0, 0, 1);
                text-align: center;
                line-height: 25px;
              }
            }
        }
        .exam_list_child {
          .child_list {
            border-top: 1px solid #eee;
            padding: 32px 0 32px 34px;
            .child_name {
              float: left;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
            .btn_box {
              float: right;
              .number {
                float: left;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000;
                line-height: 27px;
                span {
                  color: rgba(254, 76, 75, 1);
                }
              }
              .btn {
                cursor: pointer;
                margin-left: 24px;
                float: left;
                width: 72px;
                height: 25px;
                background: rgba(250, 220, 30, 1);
                border-radius: 4px;
                border: 1px solid rgba(250, 220, 30, 1);
                font-size: 12px;
                font-weight: 500;
                color: rgba(0, 0, 0, 1);
                text-align: center;
                line-height: 25px;
              }
            }
          }
        }
      }
    }
    .content_box_r1 {
      float: right;
      padding: 0 50px 50px 50px;
      width: 1268px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);

      .exam_title {
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 24px 0;
        border-bottom: 1px solid #eee;
      }
      .exam_list1 {
        text-align: center;
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: #0CD56D;
      }
    }
    .content_box_r {
      float: right;
      padding: 0 50px 50px 50px;
      width: 1268px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .exam_title {
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 24px 0;
        border-bottom: 1px solid #eee;
      }
      .exam_list {
        border-bottom: 1px solid #eee;
        .exam_list_box {
          padding: 30px 0;
          .exam_list_l {
            cursor: pointer;
            .tag {
              float: left;
              width: 23px;
              height: 23px;
              background: rgba(238, 238, 238, 1);
              border-radius: 50%;
              margin-right: 11px;
              text-align: center;
              line-height: 23px;
              img {
                width: 12px;
                height: 12px;
              }
            }
            .name {
              float: left;
            }
          }

          .operate {
            float: right;
            .btn {
              cursor: pointer;
              width: 72px;
              height: 25px;
              background: rgba(0, 69, 96, 0.04);
              border-radius: 4px;
              border: 1px solid rgba(204, 204, 204, 1);
              font-size: 12px;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
              text-align: center;
              line-height: 25px;
              float: left;
              margin-left: 24px;
            }
            .huang {
              background-color: #0CD56D;
              border: 1px solid #0CD56D;
            }
            .number {
              float: left;
              line-height: 27px;
              span {
                color: #e84233;
              }
            }
          }
        }
        .exam_list_box1{
            padding: 30px 0;
           .hand_img {
              float: left;
              margin-right: 20px;
              img {
                width: 30px;
              }
            }
            .child_name {
              float: left;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
            .btn_box {
              float: right;
              .number {
                float: left;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000;
                line-height: 27px;
                span {
                  color: rgba(254, 76, 75, 1);
                }
              }
              .btn {
                cursor: pointer;
                margin-left: 24px;
                float: left;
                width: 72px;
                height: 25px;
                background: #0CD56D;
                border-radius: 4px;
                border: 1px solid #0CD56D;
                font-size: 12px;
                font-weight: 500;
                color: rgba(0, 0, 0, 1);
                text-align: center;
                line-height: 25px;
              }
            }
        }
        .exam_list_child {
          .child_list {
            border-top: 1px solid #eee;
            padding: 32px 0 32px 34px;
            .child_name {
              float: left;
              font-size: 14px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
            .btn_box {
              float: right;
              .number {
                float: left;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000;
                line-height: 27px;
                span {
                  color: rgba(254, 76, 75, 1);
                }
              }
              .btn {
                cursor: pointer;
                margin-left: 24px;
                float: left;
                width: 72px;
                height: 25px;
                background: #0CD56D;
                border-radius: 4px;
                border: 1px solid #0CD56D;
                font-size: 12px;
                font-weight: 500;
                color: rgba(0, 0, 0, 1);
                text-align: center;
                line-height: 25px;
              }
            }
          }
        }
      }
    }
    .content_box_r1 {
      float: right;
      padding: 0 50px 50px 50px;
      width: 1268px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);

      .exam_title {
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        padding: 24px 0;
        border-bottom: 1px solid #eee;
      }
      .exam_list1 {
        text-align: center;
      }
    }
  }
}
</style>